export default __webpack_public_path__ + "static/media/ios-dark.8f57c1e2.svg";